(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-hl-fabric-standard"] && !Shopify.designMode) return;
  try {
    
  function initHLFabricStandard(section) {
    if (!section || section.dataset.hlFabricReady === 'true') return;

    section.dataset.hlFabricReady = 'true';

    var drawer = section.querySelector('[data-hl-fabric-drawer]');
    var drawerTriggers = section.querySelectorAll('[data-hl-fabric-drawer-open]');
    var drawerClose = section.querySelector('[data-hl-fabric-drawer-close]');
    var drawerPanels = section.querySelectorAll('[data-hl-fabric-drawer-content]');
    var cards = section.querySelectorAll('[data-hl-fabric-card]');
    var cardsTrack = section.querySelector('.hl-fabric-standard__cards');
    var scrollbar = section.querySelector('[data-hl-fabric-scrollbar]');
    var scrollbarThumb = section.querySelector('[data-hl-fabric-scrollbar-thumb]');

    function updateScrollbar() {
      if (!cardsTrack || !scrollbar || !scrollbarThumb) return;

      var maxScroll = cardsTrack.scrollWidth - cardsTrack.clientWidth;

      if (maxScroll <= 4) {
        scrollbar.classList.add('is-hidden');
        return;
      }

      var trackWidth = scrollbar.clientWidth;
      var thumbRatio = cardsTrack.clientWidth / cardsTrack.scrollWidth;
      var thumbWidth = Math.max(32, trackWidth * thumbRatio);
      var progress = cardsTrack.scrollLeft / maxScroll;
      var travel = Math.max(0, trackWidth - thumbWidth);

      scrollbar.classList.remove('is-hidden');
      scrollbarThumb.style.setProperty('--hl-fabric-scrollbar-thumb-width', thumbWidth + 'px');
      scrollbarThumb.style.setProperty('--hl-fabric-scrollbar-thumb-x', progress * travel + 'px');
    }

    function openDrawer(target) {
      if (!drawer) return;

      drawerPanels.forEach(function(panel) {
        panel.classList.toggle('is-active', panel.dataset.hlFabricDrawerContent === target);
      });

      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
    }

    function closeDrawer() {
      if (!drawer) return;

      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }
    }

    drawerTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        openDrawer(trigger.dataset.hlFabricDrawerOpen);
      });
    });

    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }

    if (drawer) {
      drawer.addEventListener('click', function(event) {
        if (event.target === drawer) closeDrawer();
      });
    }

    cards.forEach(function(card) {
      function toggleCard() {
        var isFlipped = card.classList.toggle('is-flipped');
        var back = card.querySelector('.hl-fabric-card__face--back');
        card.setAttribute('aria-pressed', isFlipped ? 'true' : 'false');
        if (back) back.setAttribute('aria-hidden', isFlipped ? 'false' : 'true');
      }

      card.addEventListener('click', toggleCard);
      card.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleCard();
        }
      });
    });

    if (cardsTrack) {
      cardsTrack.addEventListener('scroll', updateScrollbar, { passive: true });
      window.addEventListener('resize', updateScrollbar);
      updateScrollbar();
      setTimeout(updateScrollbar, 250);
    }
  }

  document.querySelectorAll('[data-hl-fabric-standard]').forEach(initHLFabricStandard);

  document.addEventListener('shopify:section:load', function(event) {
    initHLFabricStandard(event.target.querySelector('[data-hl-fabric-standard]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hl-presell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hl-presell')) {
    customElements.define('hl-presell', class extends HTMLElement {
      connectedCallback() {
        this.hero = this.querySelector('.hl-presell__hero');
        this.offer = this.querySelector('.hl-presell__offer');
        this.bar = this.querySelector('.hl-presell__sticky');
        const params = new URLSearchParams(location.search);
        this.querySelectorAll('[data-ps-cta]').forEach(link => {
          const url = new URL(link.href, location.origin);
          ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'preview_theme_id'].forEach(key => {
            if (params.has(key)) url.searchParams.set(key, params.get(key));
          });
          link.href = url.href;
        });
        if (!this.bar) return;
        this.observer = new IntersectionObserver(() => {
          const heroPassed = this.hero.getBoundingClientRect().bottom < 0;
          const offer = this.offer.getBoundingClientRect();
          const offerVisible = offer.top < innerHeight && offer.bottom > 0;
          this.bar.hidden = !heroPassed || offerVisible;
        }, { threshold: [0, 0.01, 1] });
        this.observer.observe(this.hero);
        this.observer.observe(this.offer);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hl-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hl-review-carousel')) {
    customElements.define('hl-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const track = this.querySelector('.hl-reviews__track');
        const prev = this.querySelector('[data-review-prev]');
        const next = this.querySelector('[data-review-next]');
        const update = () => {
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        const move = direction => {
          const item = track.querySelector('[data-review-item]');
          if (!item) return;
          track.scrollBy({left: direction * (item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        prev.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        track.addEventListener('scroll', update, {signal, passive:true});
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
        }, {signal});
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('[data-review-item]');
          if (item) track.scrollTo({left:item.offsetLeft - track.firstElementChild.offsetLeft, behavior:'instant'});
        }, {signal});
        this.observer?.disconnect();
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
